import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { CartContext } from "../contexts/CartContext";
import { ProductContext } from "../contexts/ProductContext";

import { Link, Routes, Route, useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";

const ProductDetails = () => {
  //navigate go back
  const navigate = useNavigate();

  // get the product id from url
  const { id } = useParams();
  const { addToCart } = useContext(CartContext);
  const { products } = useContext(ProductContext);

  //get the single product based on id
  const product = products.find((item) => {
    return item.id === parseInt(id);
  });

  // if product is not found
  if (!product) {
    return (
      <section className="h-screen flex justify-center items-center">
        Loading...
      </section>
    );
  }

  // destructure product
  const { title, price, description, image } = product;
  return (
    <div className="section">
      <section className="pt-[450px] md:pt-32 pb-[400px] md:pb-12 lg:py-32 h-screen flex items-center">
        <button onClick={() => navigate(-1)}>
          <IoMdArrowBack className="cursor-pointer text-4xl ml-10" />
        </button>

        <div className="container mx-auto">
          {/* image and text wrapper */}
          <div className="flex flex-col lg:flex-row items-center">
            {/* image */}
            <div className="flex flex-1 justify-center items-center mb-8 lg:mb-0">
              <img className="max-w-[200px] lg:max-w-xs" src={image} alt="" />
            </div>
            {/* text */}
            <div className="flex-1 text-center lg:text-left">
              <h1 className="text-[26px] font-medium mb-2 max-w-[450px] mx-auto lg:mx-0">
                {title}
              </h1>
              <div className="text-2xl text-red-500 font-medium mb-6">
                ₸ {price}
              </div>
              <p className="mb-8">
                🚖 Доставка: Яндекс доставка (оплачивает покупатель). <br />
                От 4х бутылок и выше - доставка бесплатная 🚀 💁‍♂ <br />{" "}
                Самовывоз: кафе LAGOM, Мәңгілік ел 40
              </p>
              <button
                onClick={() => addToCart(product, product.id)}
                className="bg-primary py-4 px-8 text-white"
              >
                Добавить в корзину
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductDetails;
